/*
export function someGetter (state) {
}
*/

export function effectiveClientAcc (state) {
  if (state.client) {
    return state.client
  } else if (state.user) {
    return state.user.clientAcc
  } else {
    return { id: 'unknown', name: 'Not Set' }
  }
}

export function effectiveClientId (state, getters) {
  return getters.effectiveClientAcc.id
}
